/**
 * 组织类型
 * @export string
 * @param {*} e number
 */
export function invoiceType (e) {
  let str = ''
  switch (e) {
    case 0:
      str = '无需发票'
      break
    case 1:
      str = '普通发票'
      break
    case 2:
      str = '增值税专用发票'
      break
    default:
      str = '无需发票'
  }
  return str
}

/**
 * 证书业务单状态
 * @export string
 * @param {*} e
 */
export function certTransStatus (e) {
  let str = ''
  switch (e) {
    case 1:
      str = '待上传资料'
      break
    case 2:
      str = '审核中'
      break
    case 3:
      str = '审核未通过'
      break
    case 4:
      str = '待付款'
      break
    case 5:
      str = '制证中'
      break
    case 6:
      str = '续期待更新'
      break
    case 7:
      str = '待解锁'
      break
    case 8:
      str = '制证中'
      break
    case 9:
      str = '待领取'
      break
    case 10:
      str = '已寄送'
      break
    case 11:
      str = '已完成'
      break
    case 12:
      str = '已取消'
      break
    case 13:
      str = '已作废'
      break
    default:
      str = '--'
  }
  return str
}
/**
 * 渠道类型
 * @param e
 */
export function appType (e) {
  let str = ''
  switch (e) {
    case 1:
      str = '官网'
      break
    case 2:
      str = '服务网点'
      break
    case 3:
      str = '接入平台'
      break
    case 4:
      str = '印章网'
      break
    case 5:
      str = '客户端'
      break
    default:
      str = '--'
  }
  return str
}
/**
 * 证件类型
 * @export string
 * @param {*} e
 */
export function IdentType (e) {
  let str = ''
  switch (e) {
    case '0':
      str = '居民身份证'
      break
    case '1':
      str = '护照'
      break
    case '2':
      str = '驾驶证'
      break
    case '3':
      str = '户口簿'
      break
    case '4':
      str = '社会保障卡'
      break
    case '5':
      str = '临时居民身份证'
      break
    case '6':
      str = '军人身份证件'
      break
    case '7':
      str = '武装警察身份证件'
      break
    case '8':
      str = '警察身份证件'
      break
    case '9':
      str = '海员证'
      break
    case 'A':
      str = '港澳居民来往内地通行证'
      break
    case 'B':
      str = '台湾居民来往大陆通行证'
      break
    case 'C':
      str = '外国人居留证'
      break
    case 'Z':
      str = '其他'
      break
    case 'O':
      str = '组织机构代码证'
      break
    case 'P':
      str = '普通营业执照'
      break
    case 'Q':
      str = '统一社会信用代码'
      break
    case 'R':
      str = '事业单位法人证书'
      break
    case 'S':
      str = '社会团体法人登记证书'
      break
    case 'T':
      str = '民办非企业单位登记证书'
      break
    case 'U':
      str = '工商登记证'
      break
    case 'V':
      str = '税务登记证'
      break
    default:
      str = '--'
  }
  return str
}

/**
 * 证书业务单类型
 * @export string
 * @param {*} e
 */
export function transactionType (e) {
  let str = ''
  switch (e) {
    case 1:
      str = '证书新办'
      break
    case 2:
      str = '证书变更'
      break
    case 3:
      str = '证书续期'
      break
    case 4:
      str = '证书注销'
      break
    // case 5:
    //   str = '证书冻结'
    //   break
    // case 6:
    //   str = '证书解冻'
    //   break
    case 7:
      str = '证书解锁'
      break
    case 9:
      str = '证书补办'
      break
    default:
      str = '--'
  }
  return str
}

/**
 * 证书状态
 * @export string
 * @param {*} e
 */
export function certStatus (e) {
  let str = ''
  switch (e) {
    case 1:
      str = '正常'
      break
    case -1:
      str = '已过期'
      break
    case -2:
      str = '注销(已续期)'
      break
    case -3:
      str = '注销(已更新)'
      break
    case -4:
      str = '已挂失'
      break
    case -5:
      str = '已注销'
      break
    // case -6:
    //   str = '注销(密钥更新)'
    //   break
    case -7:
      str = '注销(已补办)'
      break
    default:
      str = '--'
  }
  return str
}

/**
 * 组织类型
 * @export
 * @param {*} e
 */
export function orgType (e) {
  let str = ''
  switch (e) {
    case 1:
      str = '企业'
      break
    case 2:
      str = '政府/事业单位'
      break
    case 3:
      str = '其他组织'
      break
    default:
      str = '--'
  }
  return str
}

/**
 * 证书类型
 * @export
 * @param {*} e
 * @returns
 */
export function CertType (e) {
  let str = ''
  switch (e) {
    case 1:
      str = '个人证书'
      break
    case 2:
      str = '机构证书'
      break
    case 3:
      str = '机构个人证书'
      break
    default:
      str = '--'
  }
  return str
}

/**
 * 业务单附件类型
 *
 * @export
 * @param {*} e
 */
export function TransactionAttachType (e) {
  let str = ''
  switch (e) {
    case 'a':
      str = '申请表'
      break
    case 'b':
      str = '经办人身份证正面'
      break
    case 'c':
      str = '经办人身份证反面'
      break
    case 'd':
      str = '经办人手持身份证'
      break
    case 'e':
      str = '营业执照/组织机构代码证'
      break
    case 'f':
      str = '委托授权书'
      break
    default:
      str = '--'
  }
  return str
}

/**
 * 新闻类型
 *
 * @export
 * @param {*} e
 */
export function newsType (e) {
  let str = ''
  switch (e) {
    case 1:
      str = '新闻资讯'
      break
    case 2:
      str = '行业资讯'
      break
    case 3:
      str = '最新动态'
      break
    case 4:
      str = '公司新闻'
      break
    case 5:
      str = '国内热点'
      break
    default:
      str = '--'
  }
  return str
}

/**
 * 新闻详情截取简介
 *
 * @export
 * @param {*} e
 */
export function interceptText (e) {
  let str = e.replace(/<[^>]+>/g, '')
  if (str.length > 117) {
    str = str.slice(0, 117)
    str += '...'
  }

  return str
}
/**
 * 证书类型
 */
export function getCertType (e) {
  let str = ''
  switch (e) {
    case '1':
      str = '个人证书'
      break
    case '2':
      str = '机构证书'
      break
    case '3':
      str = '机构个人证书'
      break
    default:
      str = '- -'
  }
  return str
}
